<dw-ui-panel [defaultOpenedPanel]="info" [triggers]="triggers()">
  @if (entitySignal()?.id) {
    <div header-start class="mx-3">
      <document-number-tag [docRole]="entitySignal().role" [number]="entitySignal().displayNumber">
      </document-number-tag>
    </div>
  }

  <dw-grid-detail-navigation
    header-actions
    [context]="[
      GoliathDocumentEntityNames.SupplierQuote.shortName,
      GoliathDocumentEntityNames.CustomerDoc.shortName,
    ]"
  >
  </dw-grid-detail-navigation>
  <dw-grid-tabs>
    <div class="tabs">
      <ul
        ngbNav
        #nav="ngbNav"
        (navChange)="onTabChanged($event.nextId)"
        class="nav-underline nav-tabs d-flex border-0 me-md-auto"
      >
        <li [ngbNavItem]="'general'">
          <a ngbNavLink appDwNavLink>
            <i class="digi-out-alert-info me-2 text-primary"></i>{{ '::General' | abpLocalization }}
          </a>
          <ng-template ngbNavContent>
            <div ngbScrollSpy #spy="ngbScrollSpy" #scrollSpy>
              <div class="mt-2 container-panel">
                <form
                  id="generalForm"
                  [formGroup]="form"
                  [DwKeyboardShortcut]="shortcut.controlS"
                  (shortcutAction)="save()"
                >
                  <div class="card-group mb-3 mt-2 header">
                    <document-core-card
                      [form]="form"
                      [entity]="entity"
                      class="card"
                    ></document-core-card>

                    <document-supplier-document-date-card
                      [form]="form"
                      class="card"
                    ></document-supplier-document-date-card>

                    <document-supplier-card
                      [form]="form"
                      [thirdPartySelect]="thirdPartySelect"
                      [thirdPartyContacts$]="thirdPartyContacts$"
                      [thirdPartyDirectDeliveryAddress$]="thirdPartyDirectDeliveryAddress$"
                      [thirdPartyPickUpAddress$]="thirdPartyPickUpAddress$"
                      class="card card-double"
                    >
                      <div class="row row-cols-md-12 col-pad" afterContact>
                        <div class="col-md-6 p-0">
                          <label
                            for="supplierDeliveryModeId"
                            class="form-label text-primary"
                            dwInputRequired
                          >
                            {{ 'GoliathCore::DeliveryMode' | abpLocalization }}
                          </label>
                          <ng-select
                            class="form-control"
                            id="supplierDeliveryModeId"
                            formControlName="supplierDeliveryModeId"
                            bindLabel="name.current"
                            bindValue="id"
                            [loading]="coreEnumerationTypeStore.loading()"
                            [items]="coreEnumerationTypeStore.supplierDeliveryModes()"
                          >
                          </ng-select>
                        </div>

                        @switch (form.get('supplierDeliveryModeId')?.value) {
                          @case (deliveryMode.OtherSite) {
                            <div class="col-md-6 p-0">
                              <label
                                for="deliveryAddressIdSelected"
                                class="form-label text-primary"
                              >
                                {{ '::Site' | abpLocalization }}
                              </label>
                              <ng-select
                                class="form-control"
                                bindLabel="code"
                                bindValue="id"
                                formControlName="deliveryAddressIdSelected"
                                [loading]="companySiteStore.loading()"
                                [items]="companySiteStore.entities()"
                              >
                              </ng-select>
                            </div>
                          }
                          @case (deliveryMode.DirectDelivery) {
                            <div class="col-md-6 p-0">
                              <label
                                for="deliveryAddressIdSelected"
                                class="form-label text-primary"
                              >
                                {{ 'Doc::SupplierQuote:Address' | abpLocalization }}
                              </label>
                              <ng-select
                                class="form-control"
                                bindLabel="name"
                                bindValue="id"
                                formControlName="deliveryAddressIdSelected"
                                [items]="thirdPartyDirectDeliveryAddress$ | async"
                              >
                              </ng-select>
                            </div>
                          }
                          @case (deliveryMode.PickUp) {
                            <div class="col-md-6 p-0">
                              <label
                                for="deliveryAddressIdSelected"
                                class="form-label text-primary"
                              >
                                {{ 'Doc::SupplierQuote:Address' | abpLocalization }}
                              </label>
                              <ng-select
                                class="form-control"
                                bindLabel="name"
                                bindValue="id"
                                formControlName="deliveryAddressIdSelected"
                                [items]="thirdPartyPickUpAddress$ | async"
                              >
                              </ng-select>
                            </div>
                          }
                        }
                      </div>
                    </document-supplier-card>

                    <document-supplier-document-status-card
                      [form]="form"
                      [salesPersonSelect]="salesPersonSelect"
                      class="card"
                    >
                      <div class="col-md-6 p-0" afterSalesPerson>
                        <label for="supplierDocOriginId" class="form-label text-primary">
                          {{ '::DocOrigin' | abpLocalization }}
                        </label>
                        <ng-select
                          class="form-control"
                          id="supplierDocOriginId"
                          formControlName="supplierDocOriginId"
                          bindLabel="uniqueCode"
                          bindValue="id"
                          [loading]="enumerationTypeStore.loading()"
                          [items]="enumerationTypeStore.supplierDocOrigins()"
                        >
                        </ng-select>
                      </div>

                      <ng-container middle>
                        <div class="row row-cols-md-12 col-pad">
                          <div class="col-md-6 p-0">
                            <label for="reference" class="form-label text-primary">
                              {{ 'Doc::SupplierQuote:Reference' | abpLocalization }}
                            </label>
                            <input type="text" class="form-control" formControlName="reference" />
                          </div>
                          <div class="col-md-6 p-0">
                            <label
                              for="supplierQuoteStatusId"
                              class="form-label text-primary"
                              dwInputRequired
                            >
                              {{ 'Doc::QuoteStatus' | abpLocalization }}
                            </label>
                            <ng-select
                              class="form-control"
                              id="supplierQuoteStatusId"
                              formControlName="supplierQuoteStatusId"
                              bindLabel="name.current"
                              bindValue="id"
                              [loading]="enumerationTypeStore.loading()"
                              [items]="enumerationTypeStore.supplierQuoteStatus()"
                            >
                            </ng-select>
                          </div>
                        </div>
                      </ng-container>
                    </document-supplier-document-status-card>
                  </div>
                  @if (entity?.id) {
                    <div ngbScrollSpyFragment="products" dwScrollSpyItem [fragment]="'products'">
                      <document-supplier-quote-lines-grid
                        #supplierQuoteLineGrid
                        [supplierQuote]="entity"
                        [readonly]="isClosed()"
                        [thirdPartyVatSystem]="thirdParty?.vatSystem"
                        (lineUpdatedEvent)="refreshAfterLineUpdate($event)"
                        (linePricingDetailsEvent)="updatePricingDetails($event)"
                      ></document-supplier-quote-lines-grid>
                    </div>
                  }
                </form>
              </div>
            </div>
          </ng-template>
        </li>
        <li [ngbNavItem]="'conditions'">
          <a ngbNavLink appDwNavLink>
            <i class="digi-out-terms me-2 text-primary"></i
            >{{ 'Doc::CustomerQuote:Conditions' | abpLocalization }}
          </a>
          <ng-template ngbNavContent>
            <div ngbScrollSpy #spy="ngbScrollSpy" #scrollSpy>
              <document-doc-conditions class="d-block" [docForm]="form" [docRoleInput]="docRole">
              </document-doc-conditions>
            </div>
          </ng-template>
          <div class="0"></div>
        </li>
        <li [ngbNavItem]="'classification'" [disabled]="!entity?.id">
          <a ngbNavLink appDwNavLink>
            <i class="digi-out-classifications me-2 text-primary"></i
            >{{ '::Classifications' | abpLocalization }}
          </a>
          <ng-template ngbNavContent>
            <div ngbScrollSpy #spy="ngbScrollSpy" #scrollSpy>
              <document-doc-classifications
                class="d-block"
                [form]="form"
                [docClassificationValues]="docClassificationValues$ | async"
              ></document-doc-classifications>
            </div>
          </ng-template>
        </li>
        <li [ngbNavItem]="'addresses'">
          <a ngbNavLink appDwNavLink>
            <i class="digi-out-pin me-2 text-primary"></i
            >{{ 'Doc::CustomerQuote:Addresses' | abpLocalization }}
          </a>
          <ng-template ngbNavContent>
            <div ngbScrollSpy #spy="ngbScrollSpy" #scrollSpy>
              <document-doc-supplier-addresses
                class="d-block"
                [docForm]="form"
                [deliveryAddresses$]="deliveryAddress$"
                [docRoleInput]="docRole"
                [showSearch]="showSearch"
              ></document-doc-supplier-addresses>
            </div>
          </ng-template>
        </li>

        <li [ngbNavItem]="'others'">
          <a ngbNavLink appDwNavLink>
            <i class="digi-out-three-points-horizontal-1 me-2 text-primary"></i
            >{{ 'Doc::CustomerQuote:Others' | abpLocalization }}
          </a>
          <ng-template ngbNavContent>
            <div ngbScrollSpy #spy="ngbScrollSpy" #scrollSpy>
              <document-doc-supplier-others
                class="d-block"
                [docForm]="form"
                [docRoleInput]="docRole"
              ></document-doc-supplier-others>
            </div>
          </ng-template>
        </li>

        <li [ngbNavItem]="'annexes'">
          <a ngbNavLink appDwNavLink (click)="fetchAnnexes()">
            <i class="digi-out-text-file me-2 text-primary position-relative">
              <dw-ui-counter [value]="annexesCount"></dw-ui-counter>
            </i>
            {{ 'Doc::Annexes' | abpLocalization }}
          </a>
          <ng-template ngbNavContent>
            <div ngbScrollSpy #spy="ngbScrollSpy" #scrollSpy>
              <core-annexes-list
                class="d-block"
                [canDownload]="true"
                [canUpload]="true"
                [canDelete]="true"
                [canPreview]="true"
                [canEdit]="true"
                [folderName]="'quote-detail/' + entity?.id"
                [annexes]="annexesAsPromise$ | async"
                (createOrUpdateAnnexes)="createOrUpdateAnnexes($event)"
                (deleteAnnex)="deleteAnnex($event)"
                (deleteAnnexes)="deleteAnnexes($event)"
              ></core-annexes-list>
            </div>
          </ng-template>
        </li>
      </ul>
      @if (entity?.id) {
        <dw-ui-dropdown-menu [dropdownMenu]="actions()"></dw-ui-dropdown-menu>
      }
      @if (saveActionBtns().length == 1) {
        <button
          (click)="saveActionBtns()[0].action()"
          class="btn btn-primary"
          type="submit"
          form="generalForm"
          [disabled]="!form.dirty"
        >
          {{ saveActionBtns()[0].label }}
        </button>
      } @else if (saveActionBtns().length > 1) {
        <div ngbDropdown #dropdown="ngbDropdown">
          <button
            type="button"
            class="btn btn-primary text-white p-2 dropdown-toggle-with-caret"
            id="dropdowntoolbar"
            ngbDropdownToggle
          >
            {{ '::Save' | abpLocalization }}
          </button>
          <div ngbDropdownMenu aria-labelledby="dropdownActions">
            @for (btn of saveActionBtns(); track $index) {
              <button
                ngbDropdownItem
                type="submit"
                (click)="btn.action()"
                form="generalForm"
                class="d-flex align-items-center gap-2"
                [disabled]="btn.disabled()"
              >
                {{ btn.label }}
              </button>
            }
          </div>
        </div>
      }
    </div>

    <div [ngbNavOutlet]="nav" class="tab-content"></div>
  </dw-grid-tabs>

  <div side-panel-content>
    <dw-ui-side-panel #info [contentTemplate]="bodyTotal">
      <ng-template #bodyTotal>
        <document-side-panel
          [entity]="entity"
          [docService]="docService"
          [linePricingDetails]="linePricingDetails"
          [accountingCustomerOutstandingDto]="accountingCustomerOutstandingDto"
          [thirdPartyContact$]="thirdPartyContact$"
          [thirdPartyDocLinkedCount]="thirdPartyDocLinkedCount"
          [contactEmail]="contactEmail"
          [contactPhone]="contactPhone"
          [customerAddress]="customerAddress"
          [thirdParty]="thirdParty"
          [creditLimit]="creditLimit"
          (redirectToThirdPartyEvent)="redirectToThirdParty($event.thirdPartyId, $event.addContact)"
        >
          <label for="note" class="form-label text-primary mt-3">{{
            'GoliathCore::Note' | abpLocalization
          }}</label>
          @if (entity != null) {
            <textarea
              name="note"
              class="flex-grow-1"
              resize="none"
              [(ngModel)]="entity.note"
              (input)="updateNote($event)"
            ></textarea>
          }
        </document-side-panel>
      </ng-template>
    </dw-ui-side-panel>
    <dw-ui-side-panel class="side-panel--full" #chatPanel [contentTemplate]="bodyChat">
      <ng-template #bodyChat>
        <dw-core-chat
          [entityId]="entity?.id"
          [entityName]="GoliathDocumentEntityNames.SupplierQuote.shortName"
          [entityReference]="entity?.displayNumber"
        ></dw-core-chat>
      </ng-template>
    </dw-ui-side-panel>
  </div>
</dw-ui-panel>

<ng-template #report let-offcanvas>
  <dw-ui-dialog-box [title]="'Reporting::Report:ReportPdf'" [displayFooter]="false">
    <dw-report-viewer
      [reportName]="docRole"
      [dataId]="entity.id"
      [templateId]="printTemplateId"
      (pdfRequested)="downloadPdfReport()"
    ></dw-report-viewer>
  </dw-ui-dialog-box>
</ng-template>
